import axios from 'axios';

const getSubtitles = (mediaID) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      mediaId: mediaID,
    },

    url: process.env.REACT_APP_SUBTITLE_API,
  };
  return axios(requestOptions);
};

export const subtitlesServices = {
  getSubtitles,
};
